import React from 'react';

export function ToastMark({ tone = 'success' }) {
  const glyph = tone === 'error' || tone === 'warning' ? (
    <path fill="currentColor" d="M7.1 3.2h1.8L8.6 9H7.4L7.1 3.2zm.1 7.2h1.6V12H7.2v-1.6z" />
  ) : (
    <path fill="currentColor" d="M6.4 11.1 3.2 7.9l1.1-1.1 2.1 2.1 4.6-4.8 1.1 1.1-5.7 5.9z" />
  );
  return (
    <span className={`ws-toast-mark ws-toast-mark--${tone}`} aria-hidden>
      <svg viewBox="0 0 16 16" width="14" height="14">{glyph}</svg>
    </span>
  );
}

const ToastNotice = ({ title, detail }) => (
  <div className="ws-toast-copy">
    <p className="ws-toast-copy__title">{title}</p>
    {detail ? <p className="ws-toast-copy__detail">{detail}</p> : null}
  </div>
);

export function buildToastView(message, tone) {
  const notice = typeof message === 'string' || typeof message === 'number'
    ? { title: String(message), detail: '' }
    : (message || { title: 'Saved', detail: '' });
  return {
    notice,
    node: <ToastNotice title={notice.title} detail={notice.detail} />,
    icon: <ToastMark tone={tone} />
  };
}

export default ToastNotice;
